/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import WidgetWithChart from 'components/kea/widgets/common/WidgetWithChart';
import PreparedChart from './PreparedChart';
import IntlMessages from "../../../../../util/IntlMessages";

const QueriesWithoutResults = ({ queryNoResult }) => {
  const { isFetched, isFetching, curve, queries, error } = queryNoResult;
  const dataIsReady = isFetching || !isFetched;

  const chart = error ? null : <PreparedChart data={curve && curve.data} />;
  const mainNumber = error || !(queries && queries.filteredTotal)
    ? '-'
    : queries.filteredTotal;

  return (
    <WidgetWithChart
      isFetching={dataIsReady}
      title={<IntlMessages id="analytics.noResult.title" />}
      mainNumber={mainNumber}
      description={<IntlMessages id="analytics.noResult.description" />}
      chart={chart}
      tone="zeroResults"
    />
  );
};

export default QueriesWithoutResults;
